/**
 * The brand glow applied to the prompt bar's `<form>` on the dashboard and
 * reports surfaces.
 *
 * This is a bespoke, hand-tuned brand shadow — it is deliberately NOT one of
 * the `theme.css` elevation tokens (`shadow-xs`/`lg`/`xl`/`2xl`), none of which
 * carry brand tint. It is named debt pending a proper token: the values below
 * are the ones that shipped, and the only reason this constant exists is so
 * the three call sites stop drifting apart. Do not copy the literal into a
 * fourth place — import this instead.
 */
export const PROMPT_BAR_GLOW_CLASS =
  '[&_form]:shadow-[0px_4px_14px_0px_rgba(31,18,167,0.25),0px_1px_2px_0px_rgba(10,13,18,0.05)] dark:[&_form]:shadow-[0px_4px_14px_0px_rgba(31,18,167,0.35),0px_1px_2px_0px_rgba(0,0,0,0.1)]';
